import React, { useEffect, useState, useCallback, useMemo } from "react";
import ReactDom from "react-dom";
import { Link, useHistory, useParams } from "react-router-dom";
import clsx from "clsx";
import {
  Input,
  Label,
  Button,
  Row,
  Col,
  Container,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonGroup,
} from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { yupResolver } from "@hookform/resolvers/yup";

import ParticipantForm, {
  LegalParticipantSchema,
  IndividualParticipantSchema,
  ParticipantSchema,
} from "./ParticipantForm";
import {
  createContract,
  saveContract,
  sendContract,
  contractAction,
} from "../api/actions/contracts";
import { fetcher } from "../api/client";

import LoadingButton from "./LoadingButton";
import ConfirmationModal from "./ConfirmationModal";
import bootbox from "./Bootbox";
import NoContractsModal from "./NoContractsModal";
import { PDFIndex } from "../pages/PdfViewer";
import { useTranslation } from "react-i18next";
import { useProfile } from "../api/hooks/profile";
import { SignatureTypesSelect } from "./Selects/SignatureTypesSelect";
import { JurisdictionSelect } from "./Selects/JurisdictionSelect";
import { unmaskPhone, truncate } from "../utils";
import { toast } from "react-toastify";
import Checkbox from "./Checkbox";
import { languages } from "../config";
import i18n from "../i18n";

import {
  useEditor,
  useEditorActions,
  FILL_MY_DATA,
  RESET_FILL_MY_DATA,
  SET_LANGUAGE,
  SET_SIGNATURE_TYPE,
  SET_JURISDICTION,
  SET_SHIELD_TYPE,
  RESET_DOCUMENT,
  SET_PARTICIPANTS,
  SET_NUM_PAGES,
  SET_CURRENT_PAGE,
  SET_DOCUMENT,
  useEditorDispatch,
} from "../context/editor";
import { useUserLanguage } from "../hooks/useLanguages";
import IATab from "./IATab";

// const ContractSchema = Yup.object().shape({
//     language: Yup.string(),
//     shield: Yup.string(),
//     fillMyData: Yup.string(),
//     participants: Yup.array().of(ParticipantSchema)
//   })

function ContractConfiguration({
  className,
  onClose,
  contract,
  formik: {
    handleChange,
    handleSubmit,
    isSubmitting: isSending,
    values,
    errors,
    touched,
  },
  onFillMyData,
  fillMyData,
  saving,
  tabs,
  currentTab,
  header,
  footer,
  FooterComponent,
  onRequestAgreement,
  currentJurisdiction,
  currentSignatureType,
  languages,
  currentLanguage,
  onLanguageChange,
  shields,
  onShieldChange,
  shieldType,
  isPdf,
  isDynamic,
  onAddParticipant,
  numPagesArr,
  pdfUrl,
  onPDFPageClick,
  goToPage,
  isEditable,
  onDocumentLoadSuccess,
  onRemoveParticipant,
  onAddParticipantSignature,
  onSignatureTypeChange,
  onJurisdictionChange,
  handleWindow,
}) {
  const { t } = useTranslation("common");
  const [truncated, setTruncated] = useState(true);
  const [isChangeEmailOpen, setIsChangeEmailOpen] = useState(false);
  const { can } = useProfile();
  const editorDispatch = useEditorDispatch();
  const [editorState] = useEditor();
  // const {name, ...participantErrors} = errors;
  // const {name, ...participantTouched} = touched;
  // const contractErrors = {
  //     name
  // }
  // if (!isOpen || !contract) {
  //     return null;
  // }

  const [innerCurrentTab, setInnerCurrentTab] = useState(currentTab);

  const changeTab = (tabId) => () => {
    setInnerCurrentTab(tabId);
  };

  const unTruncate = () => {
    setTruncated((isTruncated) => !isTruncated);
  };

  useEffect(() => {
    setInnerCurrentTab(currentTab);
  }, [currentTab]);
  useEffect(() => {
    if (innerCurrentTab === 1) {
      handleWindow("normal");
    }
    if (innerCurrentTab === 2) {
      handleWindow("normal");
    }
    if (innerCurrentTab === 3) {
      handleWindow("IA");
    }
  }, [innerCurrentTab]);

  return (
    <Card className={`${className} bg-grey`}>
      {header && (
        <CardHeader tag={Container}>
          <Row>
            <Col md={8} xs={8}>
              <h5 className="mb-0 title font-weight-bold">
                {t("documentConfiguration")}
              </h5>
              <p className="text-muted mb-0" onClick={unTruncate}>
                {truncated ? truncate(values.name, 55) : values.name}
              </p>
            </Col>
            <Col md={4} xs={4}>
              <Button
                className="pointer float-right"
                id="closeConfig"
                color="primary"
                size="sm"
                onClick={onClose}
              >
                {t("actions.close")}
                <FontAwesomeIcon
                  icon={"times-circle"}
                  mask="far"
                  className="ml-2"
                  inverse
                />
              </Button>
            </Col>
          </Row>
        </CardHeader>
      )}
      <CardBody
        className={clsx("pb-0", "p-0 h-100")}
        style={{ marginBottom: 40 }}
      >
        {tabs && (
          <Nav tabs>
            {isPdf && (
              <NavItem>
                <NavLink
                  className={clsx(
                    "py-2 px-5",
                    innerCurrentTab === 1 && "active"
                  )}
                  onClick={changeTab(1)}
                  tag="strong"
                >
                  {t("index")}
                </NavLink>
              </NavItem>
            )}
            {editorState?.document?.aiAnalysis &&
              editorState?.document?.aiAnalysis !==
                '"no es contrato de arrendamiento de inmueble ni de compraventa"' &&
              editorState?.document?.aiAnalysis !==
                "no es contrato de arrendamiento de inmueble ni de compraventa" &&
              editorState?.document?.aiAnalysis !== "false" && (
                <NavItem>
                  <NavLink
                    className={clsx(
                      "py-2 px-5",
                      innerCurrentTab === 3 && "active"
                    )}
                    onClick={changeTab(3)}
                    tag="strong"
                  >
                    {t("IACover.tab")}
                  </NavLink>
                </NavItem>
              )}

            <NavItem>
              <NavLink
                className={clsx("py-2 px-5", innerCurrentTab === 2 && "active")}
                onClick={changeTab(2)}
                tag="strong"
              >
                {t("signers")}
              </NavLink>
            </NavItem>
          </Nav>
        )}
        <TabContent
          activeTab={innerCurrentTab}
          className={clsx(
            "bg-light pb-2 border-right border-bottom border-left overflow-auto h-100",
            !isPdf && "border-0"
          )}
        >
          {isPdf && (
            <TabPane
              tabId={1}
              className={clsx(
                "align-self-center justify-content-center overflow-auto h-100",
                innerCurrentTab === 1 && "d-flex "
              )}
            >
              <PDFIndex
                url={pdfUrl}
                numPagesArr={numPagesArr}
                onItemClick={onPDFPageClick}
                goTo={goToPage}
                onDocumentLoadSuccess={onDocumentLoadSuccess}
              />
            </TabPane>
          )}
          <TabPane tabId={2}>
            <div
              className={clsx(
                "general-configuration px-4 h-100",
                isPdf && "mt-2"
              )}
            >
              <label>{t("shield")}</label>
              <Select
                options={shields}
                value={shieldType}
                onChange={onShieldChange}
                isDisabled={!isEditable}
                styles={{ menu: (base) => ({ ...base, zIndex: 1000 }) }}
              />
              <label className="mt-2">{t("forms.language")}</label>
              <Select
                options={languages}
                value={currentLanguage}
                onChange={onLanguageChange}
                isDisabled={!isEditable}
                styles={{ menu: (base) => ({ ...base, zIndex: 1000 }) }}
              />
              <label className="mt-2">{t("forms.jurisdiction")}</label>
              <JurisdictionSelect
                onChange={onJurisdictionChange}
                value={currentJurisdiction}
                isDisabled={!isEditable}
                isPdf={false}
              />
              {/* <Select options={languages} value={currentLanguage} onChange={onLanguageChange} isDisabled={!isEditable} styles={{ menu: base => ({ ...base, zIndex: 1000 }) }} /> */}
              <label className="mt-2">{t("forms.signatureType")}</label>
              <SignatureTypesSelect
                onChange={onSignatureTypeChange}
                value={currentSignatureType}
                isDisabled={!isEditable}
                isPdf={false}
              />
            </div>
            <div>
              {/* {   
                            isPdf && isEditable &&
                            <Button 
                                className="mx-3 mt-4" 
                                size="sm" 
                                color="accent"
                                onClick={onAddParticipant}
                                disabled={!isEditable}
                            >
                                Agregar participante
                            </Button>
                        } */}
              {values?.participants &&
                Object.values(values.participants).map((participant, i) => (
                  <div key={participant._id} className="d-flex flex-column">
                    {/* { i !== 0 && <div className="border-bottom"></div> } */}
                    <ParticipantForm
                      shieldType={shieldType}
                      loading={isSending}
                      isDynamic={isDynamic}
                      key={participant._id}
                      name={`participants.${participant._id}`}
                      onChange={handleChange}
                      onRequestAgreement={onRequestAgreement}
                      onFillMyData={onFillMyData}
                      showFillMyData={
                        !fillMyData.length ||
                        fillMyData.includes(participant._id)
                      }
                      fillMyData={fillMyData}
                      participant={participant}
                      editable={isEditable}
                      errors={errors?.participants?.[participant._id]}
                      touched={errors?.participants?.[participant._id]}
                      onRemove={
                        isPdf || isDynamic ? onRemoveParticipant : undefined
                      }
                    />
                    {editorState.signatureType === "autograph" &&
                      isEditable &&
                      isPdf && (
                        <Button
                          className="align-self-end mb-2 mr-2"
                          color="primary"
                          onClick={onAddParticipantSignature(participant._id)}
                        >
                          {t("actions.addSignature")}
                        </Button>
                      )}
                    <Button
                      className="align-self-end mb-2 mr-2"
                      color="primary"
                      size="sm"
                      disabled={
                        !["SENT_TO_SIGN", "SENT_TO_FILL"].includes(
                          contract.status
                        )
                      }
                      isDisabled={
                        !["SENT_TO_SIGN", "SENT_TO_FILL"].includes(
                          contract.status
                        )
                      }
                      hidden={
                        !can("CHANGE_PARTICIPANTS_EMAIL") ||
                        contract.status === ""
                      }
                      onClick={() => setIsChangeEmailOpen(participant._id)}
                      // onClick={onAddParticipantSignature(participant._id)}
                    >
                      {t("Cambiar correo")}
                    </Button>
                    <DelegateSignatureModal
                      isChangeParticipant
                      isOpen={isChangeEmailOpen === participant._id}
                      jurisdiction={contract.jurisdiction}
                      contractId={contract._id}
                      participant={participant}
                      onClose={() => setIsChangeEmailOpen(false)}
                      onSuccess={(data) => {
                        editorDispatch({
                          type: SET_DOCUMENT,
                          document: data.contract,
                        });
                        // const updatedParticipant = data.contract.participants.find(p => p._id === participant._id)
                        // reset(updatedParticipant)
                      }}
                    />
                    <div className="border-bottom"></div>
                  </div>
                ))}

              {(isPdf || isDynamic) && isEditable && (
                <div
                  className="mx-3 my-4 color-accent pointer"
                  onClick={onAddParticipant}
                  disabled={!isEditable}
                >
                  + {t("actions.addParticipant")}
                </div>
              )}
            </div>
          </TabPane>

          {editorState?.document?.aiAnalysis &&
            editorState?.document?.aiAnalysis !==
              "no es contrato de arrendamiento de inmueble ni de compraventa" && (
              <TabPane tabId={3}>
                <IATab
                  analysis={JSON.parse(editorState?.document?.aiAnalysis)}
                />
              </TabPane>
            )}
        </TabContent>
      </CardBody>

      {footer && isEditable && (
        <CardFooter tag={Container} className="bg-light">
          {FooterComponent ? (
            <FooterComponent
              saving={saving}
              isSending={isSending}
              onGoBack={onClose}
              isEditable={isEditable}
              onSubmit={handleSubmit}
            />
          ) : (
            <Row>
              <Col sm={6}>
                <LoadingButton
                  color="default"
                  loading={saving}
                  loadingText={t("actions.saving")}
                  className="align-self-end animate-up w-100"
                  onClick={onClose}
                >
                  {t("actions.goBack")}{" "}
                  {/*<FontAwesomeIcon icon="eye" className="ml-2" /> */}
                </LoadingButton>
              </Col>
              <Col sm={6}>
                <LoadingButton
                  color="accent-100"
                  disabled={!isEditable}
                  loading={isSending}
                  loadingText={t("actions.sending")}
                  className="align-self-end text-light animate-up w-100 mt-xs-4"
                  onClick={handleSubmit}
                >
                  {t("actions.send")}
                </LoadingButton>
              </Col>
            </Row>
          )}
        </CardFooter>
      )}
    </Card>
  );
}

function getInitialValues(template) {
  if (!template.participants) return {};

  return {
    name: template.name,
    participants: template.participants.reduce((obj, participant) => {
      if (participant?._id) {
        obj[participant._id] = {
          name: "",
          last_name: "",
          email: "",
          label: "",
          phone: "",
          representative: "",
          requestAgreement: false,
          ...participant,
        };
      }

      return obj;
    }, {}),
  };
}

function getInitialTouched(template) {
  if (!template.participants) return {};

  return {
    name: false,
    participants: template.participants.reduce((obj, participant) => {
      obj[participant._id] = {
        name: false,
        last_name: false,
        email: false,
        label: false,
        phone: false,
        representative: false,
      };

      return obj;
    }, {}),
  };
}

const getParticipantsSchema = (participants) => {
  let schema = {};

  if (participants) {
    schema = participants.reduce((obj, participant) => {
      obj[participant._id] = ParticipantSchema;

      return obj;
    }, {});
  }

  return Yup.object().shape(schema);
};

function getContractSchema(contract) {
  return Yup.object().shape({
    name: Yup.string(),
    participants: getParticipantsSchema(contract.participants),
  });
}

function ContractConfigurationContainer({
  className,
  isPdf,
  isDynamic,
  tabs = true,
  currentTab = 2,
  header = true,
  footer = true,
  onReturn,
  onContractSent = () => {},
  FooterComponent,
  changeWindow,
}) {
  const { t } = useTranslation("common");
  const errorSentResponseId = "error-sending-document";
  // router hooks
  const history = useHistory();
  const { templateId, documentId } = useParams();
  const id = templateId || documentId;

  // Context
  const queryClient = useQueryClient();
  const { profile } = useProfile();
  const [editorState, editorDispatch] = useEditor();
  // Memoization
  const shieldList = useMemo(() => {
    return Array.from(Array(2).keys()).map((number) => ({
      value: `shield${number + 1}`,
      label: t(`shield`, { context: "number", number: number + 1 }),
    }));
  }, [t]);
  const [userLanguage, languageList] = useUserLanguage();
  const [initialValues, ContractSchema] = useMemo(() => {
    return [
      getInitialValues(editorState.document),
      getContractSchema(editorState.document),
    ];
  }, [editorState.document]);

  const { mutate: sendContractMutate } = useMutation(
    (payload) => fetcher(sendContract(payload)),
    {
      onSuccess: () => {
        editorDispatch({ type: RESET_DOCUMENT });
        // if (templateId) {
        //     templatesDispatch({ type: INCREMENT_SENT_CONTRACTS, templateId })
        // }
        queryClient.invalidateQueries("profile");
        setHasSucceed(true);
        setIsLoading(false);
        setSubmitting(false);
        if (onContractSent) {
          onContractSent();
        } else if (documentId) {
          history.push("/documents");
          toast.info(t("successMessages.documentCreated"));
        } else {
          setTimeout(() => {
            handleCancel();
          }, 1000);
        }
      },
      onError: (error) => {
        setHasSucceed(false);
        setIsLoading(false);
        history.replace(`/documents/${editorState.document._id}/edit`);
        toast.error(
          t(`errors.${error.message}`, t("errorMessages.sendingContract")),
          {
            toastId: errorSentResponseId,
          }
        );
      },
      onSettled: () => {
        setIsLoading(false);
      },
    }
  );

  const { mutate: saveContractMutate } = useMutation(
    (payload) => fetcher(saveContract(payload)),
    {
      onSuccess: (result) => {
        editorDispatch({ type: SET_DOCUMENT, document: result.data });
        sendContractMutate({
          _id: result.data._id,
        });
      },
      onError: () => {
        setIsLoading(false);
      },
    }
  );

  // State
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const [currentLanguage, setCurrentLanguage] = useState(
    userLanguage ?? languageList?.[0]
  );
  // const [isNoContractsOpen, setIsNoContractsOpen] = useState(false)
  const [hasSucceed, setHasSucceed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fillMyData, setFillMyData] = useState("");
  const { checkMissingSignatures, checkCredits, checkSignatureCredits } =
    useEditorActions();

  const formik = useFormik({
    initialValues,
    onSubmit: (values, actions) => {
      let hasRequestAgreement = false;

      if (editorState.shieldType.value === "shield3") {
        const participants = Object.values(values.participants);
        hasRequestAgreement = participants?.some?.((p) => p.requestAgreement);

        if (!hasRequestAgreement) {
          return toast.error(t("errors.MissingRequestAgreement"), {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }

      const hasNoCredits = checkCredits();
      const hasNoSignatureCredits = checkSignatureCredits();
      const isMissingSignatures = checkMissingSignatures();

      if (isMissingSignatures || hasNoCredits || hasNoSignatureCredits)
        return actions.setSubmitting(false);

      setHasSucceed(false);
      setIsConfirmationOpen(true);
    },
    validationSchema: ContractSchema,
    enableReinitialize: true,
  });

  useEffect(() => {
    editorDispatch({ type: SET_SHIELD_TYPE, shieldType: shieldList[0] });
  }, [shieldList, editorDispatch]);

  useEffect(() => {
    editorDispatch({
      type: SET_LANGUAGE,
      language: userLanguage ?? languageList?.[0],
    });
  }, [languageList, userLanguage, editorDispatch]);

  // useEffect(() => {

  //     if (modalsState.reset) {
  //         setFillMyData('')
  //         formik.setValues(getInitialValues(editorState.document));
  //         formik.setTouched(getInitialTouched(editorState.document));
  //         dispatch({ type: UNRESET })
  //     }
  // }, [formik, dispatch, modalsState.reset, editorState.document])

  const handleFillMyData =
    ({ name, checked }) =>
    () => {
      if (!checked) {
        editorDispatch({ type: FILL_MY_DATA, profile, name });
      } else {
        editorDispatch({ type: RESET_FILL_MY_DATA });
      }
    };

  const handleSendContract = async (values) => {
    const hasShield2Credits =
      profile?.nom151?.remaining > 0 &&
      editorState.shieldType.value === "shield2";
    const hasShield3Credits =
      profile?.shield3?.remaining > 0 &&
      editorState.shieldType.value === "shield3";
    const stampNom = hasShield2Credits || hasShield3Credits;

    const newContract = {
      ...editorState.document,
      participants: Object.values(formik.values.participants).map(
        (participant) => ({
          ...participant,
          phone: unmaskPhone(participant.phone),
          last_name:
            participant.obligation === "individual"
              ? participant.last_name
              : undefined,
          signatures: editorState.isPdf
            ? editorState.signatures[participant._id]
            : [],
        })
      ),
      language: editorState.language.value?.toUpperCase?.(),
      stampNom,
      templateId,
      shield3ValidationRequired: true,
      allowParticipantsToRefuseSignature: true,
      shield: editorState.shieldType.value,
      signatureType: editorState.signatureType,
      jurisdiction: editorState.jurisdiction,
      iaConfiguration: editorState?.iaData,
    };
    setIsLoading(true);
    // alert(JSON.stringify(values, null, 2));
    // await db.table('contracts').put({ id: modalsState.templateId, ...newContract })

    // guardamos contrato
    saveContractMutate(newContract);
  };

  useEffect(() => {
    editorDispatch({
      type: SET_PARTICIPANTS,
      participants: Object.values(formik.values?.participants ?? {}),
    });
  }, [formik.values, editorDispatch]);

  // console.log({modalsState});
  const setSubmitting = useCallback(formik.setSubmitting, [
    formik.setSubmitting,
  ]);

  const handleCancel = useCallback(() => {
    setIsConfirmationOpen(false);
    setHasSucceed(false);
    setSubmitting(false);
  }, [setSubmitting]);

  const handleClose = useCallback(() => {
    // history.push('/')
    history.goBack();
  }, [history]);

  useEffect(() => {
    if (profile?.nom151?.remaining > 0) {
      editorDispatch({
        type: SET_SHIELD_TYPE,
        shieldType: shieldList.find((shield) => shield.value === "shield2"),
      });
    }
  }, [profile, shieldList, editorDispatch]);

  function handleLanguageChange(option) {
    editorDispatch({ type: SET_LANGUAGE, language: option });
  }

  function handleSignatureTypeChange(value) {
    editorDispatch({ type: SET_SIGNATURE_TYPE, signatureType: value });
  }

  function handleJurisdictionChange(value) {
    editorDispatch({ type: SET_JURISDICTION, jurisdiction: value });
  }

  function handleShieldChange(option) {
    editorDispatch({ type: SET_SHIELD_TYPE, shieldType: option });
  }

  const handleRequestAgreement = (fieldName, checked) => () => {
    formik.setFieldValue(fieldName, !checked);
  };

  const handleDocumentLoadSuccess = ({ numPages }) => {
    editorDispatch({ type: SET_NUM_PAGES, numPages });
  };

  const handlePDFPageClick = ({ pageNumber }) => {
    editorDispatch({ type: SET_CURRENT_PAGE, pageNumber });
  };

  const goToPage = (pageNumber) => () => {
    editorDispatch({ type: SET_CURRENT_PAGE, pageNumber });
  };

  const handleAddParticipant = () => {
    editorDispatch({ type: "add-participant" });
  };

  const handleRemoveParticipant = (participantId) => () => {
    editorDispatch({ type: "remove-participant", participantId });
  };

  const handleAddParticipantSignature = (participantId) => () => {
    editorDispatch({ type: "add-signature", participantId });
  };

  return (
    <React.Fragment key={id}>
      <ContractConfiguration
        className={className}
        contract={editorState.document}
        saving={false}
        formik={formik}
        tabs={tabs}
        header={header}
        footer={footer}
        FooterComponent={FooterComponent}
        currentTab={currentTab}
        onClose={onReturn ?? handleClose}
        onFillMyData={handleFillMyData}
        fillMyData={editorState.fillMyData}
        disableStampNom={profile.nom151 && profile.nom151.remaining <= 0}
        onLanguageChange={handleLanguageChange}
        currentLanguage={editorState.language}
        currentJurisdiction={editorState.jurisdiction}
        currentSignatureType={editorState.signatureType}
        languages={languageList}
        shields={shieldList}
        shieldType={editorState.shieldType}
        onShieldChange={handleShieldChange}
        isPdf={editorState.isPdf}
        isDynamic={editorState.isDynamic}
        isEditable={editorState.isEditable}
        onRequestAgreement={handleRequestAgreement}
        numPagesArr={editorState.numPagesArr ?? []}
        pdfUrl={editorState.document?.importedPdf}
        onPDFPageClick={handlePDFPageClick}
        goToPage={goToPage}
        onDocumentLoadSuccess={handleDocumentLoadSuccess}
        onAddParticipant={handleAddParticipant}
        onRemoveParticipant={handleRemoveParticipant}
        onAddParticipantSignature={handleAddParticipantSignature}
        onSignatureTypeChange={handleSignatureTypeChange}
        onJurisdictionChange={handleJurisdictionChange}
        handleWindow={(tab) => changeWindow(tab)}
      />
      <ConfirmationModal
        isOpen={isConfirmationOpen}
        hasSucceed={hasSucceed}
        isLoading={isLoading}
        onConfirm={handleSendContract}
        confirmText={t("actions.send")}
        cancelText={t("actions.makeChanges")}
        question={t("sendDocumentQuestion")}
        onCancel={handleCancel}
        participants={editorState.participants}
      />
      {/* <NoContractsModal
            isOpen={isNoContractsOpen}
            onRefer={handleRefer}
            referText={t('actions.send')}
            cancelText={t('actions.cancel')}
            onCancel={handleNoContractsCancel}
        /> */}
    </React.Fragment>
  );
}

export default ContractConfigurationContainer;

export function useObligationList({ jurisdiction = "mx" }) {
  const { t } = useTranslation();

  const obligationsMap = useMemo(() => {
    return new Map([
      [
        "individual",
        {
          label: t("editor.config.participant_individial"),
          value: "individual",
          description: t("editor.config.participant_individial"),
        },
      ],
      [
        "legal",
        {
          label: t("editor.config.participant_legal", {
            context: jurisdiction,
          }),
          value: "legal",
          description: t("editor.config.participant_legal", {
            context: jurisdiction,
          }),
        },
      ],
    ]);
  }, [t]);

  return {
    obligationsMap,
    obligationsArray: Array.from(obligationsMap.values()),
  };
}

function ObligationSelect({ jurisdiction, value, onChange, ...props }) {
  const { obligationsArray, obligationsMap } = useObligationList({
    jurisdiction,
  });
  const [realValue, setRealValue] = useState(null);

  useEffect(() => {
    if (obligationsMap.get(value)) {
      setRealValue(obligationsMap.get(value));
    } else {
      setRealValue(null);
    }
  }, [obligationsMap, value]);

  const handleChange = (option) => {
    onChange(option?.value || null, option);
  };

  return (
    <Select
      options={obligationsArray}
      value={realValue}
      onChange={handleChange}
      {...props}
    />
  );
}

function DelegateSignatureModal({
  isOpen,
  isChangeParticipant,
  contractId,
  jurisdiction,
  participant,
  onClose,
  onSuccess,
}) {
  const { t } = useTranslation();
  const { register, watch, control, errors, getValues, handleSubmit, valuda } =
    useForm({
      resolver: yupResolver(ParticipantSchema),
    });
  const obligation = watch(
    "obligation",
    participant.obligation || "individual"
  );
  const { mutate: mutateDelegateSign } = useMutation(
    ({ contractId, ...payload }) =>
      fetcher(contractAction(contractId, "delegatesign", payload)),
    {
      onSuccess: (data) => {
        onClose();
        onSuccess(data);
      },
      onError: (error) => {
        toast.error(t(`errors.${error.message}`, t("errors.GeneralError")));
      },
    }
  );

  const changeParticipant = async (data) => {
    let delegateQuestion = t("contracts.new.delegate_signature", {
      name: data.name,
      last_name: data.last_name,
    });
    if (isChangeParticipant) delegateQuestion = t("ask_change_participant");

    const res = await bootbox.confirm(delegateQuestion);
    if (!res) return;

    mutateDelegateSign({
      ...participant,
      ...data,
      participantId: participant._id,
      contractId,
      isChangeParticipant,
    });
  };

  const handleSend = async () => {
    handleSubmit(() => {
      const data = getValues();
      changeParticipant(data);
    })();
  };

  console.log({ errors });

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} centered>
      <ModalHeader toggle={onClose}>
        {isChangeParticipant ? (
          t("sign.change_participant")
        ) : (
          <h4>{t("sign.delegate_title")}</h4>
        )}
        {!isChangeParticipant && (
          <p className="sub-title text-muted">{t("sign.delegate_subtitle")}</p>
        )}
      </ModalHeader>
      <ModalBody className="p-2 d-flex flex-column">
        <div className="fields">
          {/* <div className="col-xs-6 form-group">
                        <label>{t('editor.config.participant_type') }<span className="text-primary">*</span></label>
                        <Controller
                            control={control}
                            name="obligation" 
                            defaultValue={participant.obligation}
                            render={({ onChange, onBlur, value}) => (
                                <ObligationSelect
                                    onChange={(value, option) => {
                                        onChange(value)
                                    }}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            maxHeight: 35
                                        }),
                                        container: (provided) => ({
                                            ...provided,
                                            width: '100%',
                                            height: 30
                                        }),
                                    }}
                                    value={value}
                                    onBlur={onBlur}
                                />
                            )}
                        />
                    </div> */}
          <input
            type="hidden"
            name="obligation"
            defaultValue={participant.obligation}
            ref={register}
          />
          <input
            type="hidden"
            name="label"
            defaultValue={participant.label}
            ref={register}
          />
          {obligation === "individual" && (
            <div className="col-xs-6 form-group" id="name">
              <label>
                {t("sign.delegate_name")}
                <span className="text-primary">*</span>
              </label>
              <input
                type="text"
                className={clsx(
                  "form-control input-sm",
                  errors.name && "is-invalid"
                )}
                name="name"
                placeholder={t("sign.delegate_name_placeholder")}
                defaultValue={participant.name}
                ref={register}
              />
              <small className="text-danger">
                {" "}
                {errors.name && t(`errors.${errors.name?.message}`)}
              </small>
            </div>
          )}
          {obligation === "legal" && (
            <div className="col-xs-6 form-group" id="participant_company">
              <label>{t("sign.delegate_participant_company")}:</label>
              <input
                type="text"
                className="form-control input-sm"
                name="name"
                className={clsx(
                  "form-control input-sm",
                  errors.name && "is-invalid"
                )}
                placeholder={t("sign.delegate_participant_company_placeholder")}
                defaultValue={participant.name}
                ref={register}
              />
              <small className="text-danger">
                {" "}
                {errors.name && t(`errors.${errors.name?.message}`)}
              </small>
            </div>
          )}
          {obligation === "individual" && (
            <div className="col-xs-6 form-group" id="lastname">
              <label>
                {t("sign.delegate_last_name")}
                <span className="text-primary">*</span>
              </label>
              <input
                type="text"
                name="last_name"
                className={clsx(
                  "form-control input-sm",
                  errors.last_name && "is-invalid"
                )}
                defaultValue={participant.last_name}
                placeholder={t("sign.delegate_last_name_placeholder")}
                ref={register}
              />
              <small className="text-danger">
                {" "}
                {errors.last_name && t(`errors.${errors.last_name?.message}`)}
              </small>
            </div>
          )}
          {obligation === "legal" && (
            <div className="col-xs-6 form-group" id="representative">
              <label>{t("sign.delegate_last_representative")}</label>
              <input
                type="text"
                className={clsx(
                  "form-control input-sm",
                  errors.representative && "is-invalid"
                )}
                name="representative"
                defaultValue={participant.representative}
                placeholder={t("sign.delegate_last_representative_placeholder")}
                ref={register}
              />
              <small className="text-danger">
                {" "}
                {errors.representative &&
                  t(`errors.${errors.representative?.message}`)}
              </small>
            </div>
          )}
          <div className="col-xs-6 form-group">
            <label>
              {t("sign.delegate_email")}
              <span className="text-primary">*</span>
            </label>
            <input
              type="text"
              className={clsx(
                "form-control input-sm",
                errors.email && "is-invalid"
              )}
              name="email"
              defaultValue={participant.email}
              placeholder={t("sign.delegate_email_placeholder")}
              ref={register}
            />
            <small className="text-danger">
              {" "}
              {errors.email && t(`errors.${errors.email?.message}`)}
            </small>
          </div>

          <div className="col-xs-6 form-group">
            <label>{t("sign.delegate_phone")}</label>
            <input
              type="text"
              className={clsx(
                "form-control input-sm",
                errors.phone && "is-invalid"
              )}
              name="phone"
              defaultValue={participant.phone}
              placeholder={t("sign.delegate_phone_placeholder")}
              ref={register}
            />
            <small className="text-danger">
              {" "}
              {errors.phone && t(`errors.${errors.phone?.message}`)}
            </small>
          </div>
          {jurisdiction === "br" && (
            <>
              <div className="col-xs-6 form-group">
                <label>Cargo</label>
                <input
                  type="text"
                  required
                  className={clsx(
                    "form-control input-sm",
                    errors.cargo && "is-invalid"
                  )}
                  name="cargo"
                  defaultValue={participant.cargo}
                  placeholder="cargo"
                  ref={register}
                />
                <small className="text-danger">
                  {" "}
                  {errors.cargo && t(`errors.${errors.cargo?.message}`)}
                </small>
              </div>
              <div className="col-xs-6 form-group">
                <label>RG</label>
                <input
                  type="text"
                  required
                  className="form-control input-sm"
                  name="rg"
                  className={clsx(
                    "form-control input-sm",
                    errors.rg && "is-invalid"
                  )}
                  placeholder="rg"
                  defaultValue={participant.rg}
                  ref={register}
                />
                <small className="text-danger">
                  {" "}
                  {errors.rg && t(`errors.${errors.rg?.message}`)}
                </small>
              </div>
              <div className="col-xs-6 form-group">
                <label>CPF</label>
                <input
                  type="text"
                  required
                  className={clsx(
                    "form-control input-sm",
                    errors.cpf && "is-invalid"
                  )}
                  name="cpf"
                  placeholder="cpf"
                  defaultValue={participant.cpf}
                  ref={register}
                />
                <small className="text-danger">
                  {" "}
                  {errors.cpf && t(`errors.${errors.cpf?.message}`)}
                </small>
              </div>
            </>
          )}
          {jurisdiction === "pr" && (
            <>
              <div className="col-xs-6 form-group">
                <label>DNI/C.E./otro</label>
                <input
                  type="text"
                  required
                  className="form-control input-sm"
                  name="cpf"
                  className={clsx(
                    "form-control input-sm",
                    errors.cpf && "is-invalid"
                  )}
                  placeholder="DNI/C.E./otro"
                  defaultValue={participant.cpf}
                  ref={register}
                />
                <small className="text-danger">
                  {" "}
                  {errors.cpf && t(`errors.${errors.cpf?.message}`)}
                </small>
              </div>
              <div className="col-xs-6 form-group">
                <label>Cargo</label>
                <input
                  type="text"
                  required
                  className="form-control input-sm"
                  name="cargo"
                  className={clsx(
                    "form-control input-sm",
                    errors.cargo && "is-invalid"
                  )}
                  placeholder="cargo"
                  defaultValue={participant.cargo}
                  ref={register}
                />
                <small className="text-danger">
                  {" "}
                  {errors.cargo && t(`errors.${errors.cargo?.message}`)}
                </small>
              </div>
            </>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <ButtonGroup className="d-flex flex-grow-1">
          <Button color="default" data-action="cancel" onClick={onClose}>
            {t("sign.delegate_cancel")}
          </Button>
          <Button color="primary" data-action="send" onClick={handleSend}>
            {isChangeParticipant
              ? t("sign.change_send")
              : t("sign.delegate_send")}
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  );
}
